<template>
  <ul v-show="display" class="CartItem__Options">
    <li v-for="option in props.options" :key="option" class="CartItem__Option">
      <p class="p5">{{ option.name }}: {{ option.value }}</p>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
});

const display = computed(() => {
  const options = Array.from(props.options) ?? [];
  const searchForDefaults = options.filter((option) =>
    option.name.includes('Title')
  );
  return searchForDefaults.length <= 0;
});
</script>
